<template>
  <crud-modal
    :show="show"
    title="Jerarquía del Atributo"
    size="lg"
    :show-save="false"
    cancel-text="Cerrar"
    nested
    @close="$emit('close')"
  >
    <div v-if="atributo">
      <div class="mb-1">
        Id Atributo: <b>{{ atributo.id_atributo }}</b>
      </div>
      <div class="mb-3">
        Atributo: <b>{{ atributo.atributo }}</b>
        <small v-if="descripcion" class="text-muted d-block mt-1">
          {{ descripcion }}
        </small>
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-striped mb-0" style="table-layout: fixed">
          <thead>
            <tr>
              <th scope="col" width="160" class="text-center">Nivel</th>
              <th scope="col" class="text-left">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item of jerarquia" :key="item.nivel">
              <td class="text-center">
                <span
                  class="badge"
                  :class="{
                    'badge-primary': item.nivel == 'servicio',
                    'badge-info': item.nivel == 'producto',
                    'badge-warning text-dark': item.nivel == 'operador',
                    'badge-secondary': item.nivel == 'tipo_suscripcion',
                    'badge-default-hierarchy bg-white text-dark border border-dark': item.nivel == 'default',
                  }"
                >
                  {{ item.nivel }}
                </span>
              </td>
              <td class="text-left" :title="item.valor" style="word-wrap: break-word">
                <span v-if="item.valor">{{ item.valor }}</span>
                <span v-else class="text-muted font-italic">(Sin valor configurado)</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </crud-modal>
</template>

<script>
import CrudModal from "../utiles/CrudModal.vue";

export default {
  name: "AtributosJerarquiaModal",
  components: {
    CrudModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    atributo: {
      type: Object,
      default: null,
    },
    jerarquia: {
      type: Array,
      default: () => [],
    },
    descripcion: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.badge-default-hierarchy {
  background-color: #ffffff !important;
  color: #000000 !important;
  border: 1px solid #000000 !important;
}
</style>
